module.exports = __webpack_public_path__ + "static/img/AIphotoNo.47bbe295.png";